
import { v4 as uuidv4 } from 'uuid';
/**
 * @user object has userId and token
 */
export const setUserInLocalStorage = (user) => {
   localStorage.setItem('userId', user.userId);
   localStorage.setItem('token', user.token);
}

/**
 * 
 * @returns The user id of the user
 */
export const getUserId = () => {
   return localStorage.getItem('userId');
}

/**
 * 
 * @returns The user id of the user
 */
export const getUserToken = () => {
   return localStorage.getItem('token');
}

/**
 * Sign out the user and clear the localstorage
 */
export const clearLocalStorage = () => {
   localStorage.removeItem('userId');
   localStorage.removeItem('token');
   localStorage.clear()
}

/**
 * 
 * @returns If the user is loggedIn or not
 */
export const isUserLoggedIn = () => {
   if (localStorage.getItem('userId')) {
      return true;
   } else {
      return false;
   }
}



//====================Details set for session user only=============================================//
export const setSessionUserName = (name) => {
   localStorage.setItem('session_user_id',uuidv4())
   localStorage.setItem('session_user_name', name);
}
export const setSessionUserImage = (image) => {
   localStorage.setItem('session_user_image', image);
}
export const setSessionUserAge = (value) => {
   localStorage.setItem('is_age_above_E', value);
}

export const getSessionUserAge = (value) => {
   return  localStorage.getItem('is_age_above_E');
}
export const setSessionVenuePass = (value) => {
     localStorage.setItem('venue_pass',value);
}
export const setUserId = (value) => {
   localStorage.setItem('userId',value);
}
export const setSessionVenueId = (value) => {
     localStorage.setItem('venue_id',value);
}
export const setSessionImage = (image) => {
   localStorage.setItem('session_user_image', image);
}
export const getSessionVenueId = () => {
   return  localStorage.getItem('venue_id');
}
export const getSessionVenuePass = () => {
   return  localStorage.getItem('venue_pass');
}
export const getSessionImage = () => {
  return localStorage.getItem('session_user_image');
}
export const getSessionUserName = () => {
   return localStorage.getItem('session_user_name');
}
export const getSessionUserId = () => {
   return localStorage.getItem('session_user_id');
}

export const getSessionUserImage = ()=>{
   return localStorage.getItem('session_user_image');
}

